import type { TOC } from '@ember/component/template-only';
import type { WithBoundArgs } from '@glint/template';
import type { EmployeeExtension as EmployeeModel } from 'tio-data/data/resources/employee.ext';
import type { AccountingPaymentExtension as AccountingPaymentModel } from 'tio-data/data/resources/accounting-payment.ext';
import BaseAccountingPayments from 'tio-common/components/contributions/accounting-payments';
import Table from './accounting-payments/table';
import Summary from 'tio-common/components/contributions/accounting-payments/summary';

interface AccountingPaymentsSummaryData {
  total?: number | null;
}

export interface ContributionsAccountingPaymentsSignature {
  Args: {
    employee: EmployeeModel;
  };
  Blocks: {
    default: [
      {
        isLoading: boolean;
        paymentData: AccountingPaymentModel[];
        summaryData: AccountingPaymentsSummaryData;
        table: WithBoundArgs<typeof Table, 'model' | 'isLoading'>;
        summary: WithBoundArgs<typeof Summary, 'model'>;
      },
    ];
  };
}

const ContributionsAccountingPaymentsComponent: TOC<ContributionsAccountingPaymentsSignature> =
  <template>
    <BaseAccountingPayments @employee={{@employee}} as |base|>
      {{yield
        (hash
          paymentData=base.paymentData
          summaryData=base.summaryData
          isLoading=base.isLoading
          table=(component Table model=base.paymentData isLoading=base.isLoading)
          summary=(component Summary model=base.summaryData)
        )
      }}
    </BaseAccountingPayments>
  </template>;

export default ContributionsAccountingPaymentsComponent;
